import React, { useState, useEffect } from 'react';
import api from '@api';
import { NavLink } from 'react-router-dom';
import './TeamListPublic.css';
import { useDomain } from '@useDomain';

function TeamListPublic() {
  const [leagues, setLeagues] = useState([]);
  const [selectedLeague, setSelectedLeague] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seasons, setSeasons] = useState("")
  const [activeSeason, setActiveSeason] = useState(null);
  const leagueOrder = [
    "Fountain Valley",
    "Tustin Columbus",
    "Irvine Valley College"
  ];

  const dayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];


  const { slug, domain } = useDomain();

  useEffect(() => {
    const fetchSeasonAndLeagues = async () => {
      try {
        if (!slug && !domain) {
          console.warn("No slug or domain available, skipping fetch");
          return;
        }

        const seasonRes = await api.get(`/api/seasonsv2`, {
          params: slug ? { slug } : { domain },
        });

        const allSeasons = seasonRes.data.seasons || [];
        const active = allSeasons.find(season => season.active);

        if (!active) {
          console.warn("No active season found.");
          return;
        }

        setActiveSeason(active);

        const res = await api.get(`/api/seasonsv2/${active.id}/leagues-with-teams-public`, {
          params: slug ? { slug } : { domain },
        });

        const leaguesWithTeams = (res.data.leagues || []).map(league => {
          const teams = (league.teams || []).map(team => ({
            ...team,
            seasonId: active.id,
            seasonName: active.name,
          }));

          return {
            ...league,
            teams,
            seasonName: active.name,
            seasonId: active.id,
          };
        });

        setLeagues(leaguesWithTeams);
      } catch (error) {
        console.error("Error fetching season and leagues:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeasonAndLeagues();
  }, [domain, slug]);



  //   useEffect(() => {
  //     const fetchLeagues = async () => {
  //       try {
  //         if (!slug && !domain) {
  //   console.warn("No slug or domain available, skipping fetch");
  //   return;
  // }
  //         const response = await api.get(`/api/seasonsv2/${season_id}/leagues`, {
  //           params: slug ? { slug } : { domain }
  //         });
  //         const filteredLeagues = response.data.leagues.filter(
  //           (league) => league.season && league.season.isActive && league.teams.length > 0
  //         );

  //         setLeagues(filteredLeagues || []);

  //       } catch (error) {
  //         console.error("Error fetching leagues with teams:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     fetchLeagues();
  //   }, [domain, slug]);


  const selectedLeagueObj =
    selectedLeague && selectedLeague !== "ALL"
      ? leagues.find(l => l.id === Number(selectedLeague))
      : null;

  const teams =
    selectedLeague === "ALL"
      ? leagues.flatMap(league => league.teams)
      : selectedLeagueObj?.teams || [];




  if (loading) return null;
  console.log(leagues)


  const isAllLeagues = selectedLeague === "";

  return (
    <div className="teamListPublic-container">
      <div className="teamPublic-league-name-container">
        <h2 className="teamPublic-league-title">
          <select
            id="league-filter"
            value={selectedLeague ?? ""}
            onChange={(e) => setSelectedLeague(e.target.value)}
          >
            {selectedLeague === null && (
              <option value="">Select a league</option>
            )}
            <option value="ALL">All Leagues</option>


            {[...leagues]
              .sort((a, b) => {
                const locationIndexA = leagueOrder.findIndex(loc => a.name.includes(loc));
                const locationIndexB = leagueOrder.findIndex(loc => b.name.includes(loc));

                if (locationIndexA !== locationIndexB) {
                  if (locationIndexA === -1) return 1;
                  if (locationIndexB === -1) return -1;
                  return locationIndexA - locationIndexB;
                }

                // If same location, sort by day
                const dayA = dayOrder.find(day => a.name.includes(day)) || "";
                const dayB = dayOrder.find(day => b.name.includes(day)) || "";

                const dayIndexA = dayOrder.indexOf(dayA);
                const dayIndexB = dayOrder.indexOf(dayB);

                if (dayIndexA === -1 && dayIndexB === -1) return a.name.localeCompare(b.name);
                if (dayIndexA === -1) return 1;
                if (dayIndexB === -1) return -1;
                return dayIndexA - dayIndexB;
              })


              .map((league) => (

                <option key={`${league.id}-${league.seasonId}`} value={league.id}>
                  {league.name} ({league.seasonName})
                </option>
              ))}
          </select>

        </h2>
      </div>

      {teams.length > 0 ? (
        <div className="teamPublic-table-container">
          <table className="teamPublic-table">
            <thead>
              <tr className="standings-head-font">
                <th>Position</th>
                <th>Team</th>
                <th>Captain</th>
                {isAllLeagues && <th>League</th>}
                <th>Wins</th>
                <th>Losses</th>
                <th>FT%</th>
                <th>3PM</th>
              </tr>
            </thead>
            <tbody>
              {[...teams]
                .map(team => ({
                  ...team,
                  winPercentage: team.wins + team.losses > 0
                    ? ((team.wins / (team.wins + team.losses)) * 1).toFixed(3)
                    : "0.00",
                }))
                .sort((a, b) => {
                  const aWinPct = parseFloat(a.winPercentage);
                  const bWinPct = parseFloat(b.winPercentage);

                  if (bWinPct !== aWinPct) return bWinPct - aWinPct;

                  if (a.losses !== b.losses) return a.losses - b.losses;

                  // Secondary tiebreaker: more wins ranks higher
                  return b.wins - a.wins;

                })
                .map((team, index) => (
                  <tr key={`${team.id}-${team.leagueName}-${team.seasonName}`} className="standings-font">

                    <td>{index + 1}</td>
                    <td>
                      <NavLink to={slug ? `/${slug}/teams/${team.id}` : `/teams/${team.id}`}>
                        {team.name}
                      </NavLink>
                    </td>
                    <td>
                      <NavLink to={slug ? `/${slug}/players/${team.captain_id}` : `/players/${team.captain_id}`}>
                        {team.captain}
                      </NavLink>
                    </td>
                    {isAllLeagues && <td>{team?.leagueName}</td>}
                    <td>{team.wins}</td>
                    <td>{team.losses}</td>
                    <td>{team.ftPercentage}</td>
                    <td>{team.total3PM}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
          <p className="standings-select-note">Please Select Filter Option</p>
      )}
    </div>
  );
}

export default TeamListPublic;
